<template>
  <div>
     <vs-breadcrumb>
      <li>
        <a  aria-current="page" style="color: rgba(0,0,0,.4);" title="Setting">Setting</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li>
        <router-link :to="'network'" title="Network">Network</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">View Network</li>
    </vs-breadcrumb>
  
<vs-row
  vs-type="flex" vs-justify="space-between" vs-w="12">
  <vs-col  vs-w="12" vs-sm="6" vs-xs="12" >
    <vs-card style="border-radius: 20px;">
         <vs-tabs alignment="right">
      <vs-tab label="Network">
        <div><br>
 <h3 ><b><vs-icon icon="wifi"></vs-icon> Network : </b>{{name}}</h3><br>
          <vs-row style="align-items: center;" vs-w="12">
            <vs-col vs-lg="6" vs-xs="12">
          <span class="text--primary"><b>Sensor Count :</b> {{sc}}</span>
        </vs-col>
        <vs-col vs-lg="6" vs-xs="12">
          <vs-row style="align-items: center;">
             <span><b> Gateway Count : </b> {{gwc}} </span>
             <vs-button color="warning" type="line" icon="create" @click="editadminemail">Edit</vs-button>
             </vs-row>
          </vs-col> </vs-row>
        </div>
      </vs-tab>
      <vs-tab label="Add Sensor ">
        <div>
          <h4 class="mb-3"><b>Add New Device</b></h4>
           <AddDevice  />
        </div>
      </vs-tab>
      <vs-tab label="Add Gateway">
        <div>
          <h4 class="mb-3"><b>Add New Gateway</b></h4>
            <AddGateway  />
        </div>
      </vs-tab>
     
    </vs-tabs>
         
         
      </vs-card>
  </vs-col>
 
</vs-row>














<vs-row

  vs-type="flex" vs-justify="space-between" vs-w="12">
  <vs-col  vs-w="6" vs-sm="6" vs-xs="12" >
   <vs-card style=" border-radius: 20px;">


       <vs-list  >
    <vs-list-header icon="signal_cellular_alt" title="Sensor Lists" style="font-size: 18px;" color="#147efb"></vs-list-header>
    
     <vs-collapse  >
     <vs-collapse-item  open v-for="item in sensor" :key="item.id">
       <div slot="header">
        
 
   
         <h6><span><vs-icon v-if="item.active==0" icon="fiber_manual_record" color="grey" size="15px"></vs-icon></span> 
         <span><vs-icon v-if="item.active==1" icon="fiber_manual_record" color="warning" size="15px"></vs-icon></span>
        <span><vs-icon v-if="item.active==2" icon="fiber_manual_record" color="primary" size="15px"></vs-icon></span> {{item.name}}</h6>
         
         
       </div>
       <vs-row style="display: flex;
  align-items: center;">
  <vs-col vs-type="flex"  vs-w="4">
   <a style="color:#147efb;">&nbsp;Serial :&nbsp;{{item.serial_id}}</a>
  </vs-col>
  <vs-col vs-type="flex" vs-w="4">
     <a style="color:#147efb;">&nbsp;Type :&nbsp;{{item.type}}</a>
  </vs-col>
  <vs-col vs-type="flex"  vs-w="2">
    <vs-button  color="primary"   size="small" type="flat" icon="add_circle" @click="link2(item)">View</vs-button>
  </vs-col>
  <vs-col vs-type="flex" vs-w="2">
      <vs-button  size="small" color="danger" type="flat" icon="delete" @click="del(item)">Delete</vs-button>
  </vs-col>
</vs-row>
       &nbsp;&nbsp;&nbsp;&nbsp;    <br>
 
        </vs-collapse-item>
     
    </vs-collapse>
  </vs-list>
    
    
    </vs-card>
  </vs-col>
  <vs-col  vs-w="6" vs-sm="6" vs-xs="12" >
    <vs-card style=" border-radius: 20px;">


       <vs-list  >
    <vs-list-header icon="router" title="Gateway Lists" style="font-size: 18px;" color="#28a745"></vs-list-header>
     <vs-collapse >
     <vs-collapse-item open v-for="item in gateway" :key="item.id">
       <div slot="header">
        
 

         <h6><span><vs-icon icon="fiber_manual_record" color="primary" size="15px"></vs-icon></span> {{item.name}}</h6>
       </div>
      <vs-row style="display: flex;
  align-items: center;">
  <vs-col vs-type="flex"  vs-w="4">
   <a style="color:#28a745;">&nbsp;Serial :&nbsp;{{item.serial_id}}</a>
  </vs-col>
  <vs-col vs-type="flex" vs-w="4">
     <a style="color:#28a745;">&nbsp;Type :&nbsp;{{item.type}}</a>
  </vs-col>
  <vs-col vs-type="flex"  vs-w="2">
    <vs-button  color="primary"   size="small" type="flat" icon="add_circle" @click="link3(item)">View</vs-button>
  </vs-col>
  <vs-col vs-type="flex" vs-w="2">
      <vs-button  size="small" color="danger" type="flat" icon="delete" @click="del(item)">Delete</vs-button>
  </vs-col>
</vs-row>
        </vs-collapse-item>
     
    </vs-collapse>
  </vs-list>
    
    
    </vs-card>
  </vs-col>
</vs-row>

  </div>
</template>

<script>
import AddDevice from '../Subpage/AddDevice'
import AddGateway from '../Subpage/AddGateway'
export default {
  name: "ViewNetwork",
  props: [
    'id',
    'name',
    'sc',
    'gwc'
  ],
  data: () => ({
    sensor: [],
    gateway:[],
    gatewayid: '',
    role: ''
  }),
  components: {
    AddDevice,
    AddGateway 
  },
  methods:{
    link(){
      this.$router.push({
        name: 'AddDevice',
        params: {
          nwname: this.name,
          nwid: this.id
        }
      })
    },
    linkgw(){
      this.$router.push({
        name: 'AddGateway',
        params: {
          nwname: this.name,
          nwid: this.id
        }
      })
    },
    link2(item){
      this.$router.push({
        name: 'SensorDashboard',
        params: {
          nwname: this.name,
          nwid: this.id,
          sensorid: item.serial_id,
          gatewayid: this.gatewayid,
          type: item.type,
          name: item.name
        }
      })
    },
    link3(item){
      this.$router.push({
        name: 'ViewGateway',
        params: {
          gateway: item
        }
      })
    },
    del(item){
      this.$API.post('sensordel', {
        id: item.serial_id
      }).then(() => {})
      this.$vs.notify({
        title: "Delete Network",
        text: "Complete!",
        color: "danger",
        position: "top-center",
        icon: 'check'
      });
      setTimeout(() => {
        location.reload()
      }, 500);
    }
  },
  created() {
    this.role = this.$session.get('role')
    this.$API.get('sensor/'+this.id).then((result) => {
      this.sensor = result.data
    })
    this.$API.get('gateway/network/'+this.id).then((result) => {
      this.gateway = result.data
      this.gatewayid = this.gateway[0].serial_id
      console.log( this.sensor )
    })
  }
}
</script>